<template>
  <div v-if="badgeSrc" class="box-rank">
    <div class="rank-inner">
      <img :src="badgeSrc" alt="VIP Badge" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'BoxRank',

  props: {
    /* 🔹 Chat gibi yerlerde dışarıdan verilen VIP level */
    vipLevelData: { type: Object, default: null },

    /* 🔹 Geriye uyumluluk */
    vipBadgeImage: { type: String, default: null }
  },

  computed: {
    ...mapGetters('vip', ['vipLevel']),

    resolvedVipLevel() {
      // 1️⃣ Prop ile geldiyse onu kullan (chat)
      if (this.vipLevelData) return this.vipLevelData;

      // 2️⃣ Store’dan auth user
      if (this.vipLevel) return this.vipLevel;

      return null;
    },

    badgeSrc() {
      if (this.resolvedVipLevel?.badge) {
        return this.resolvedVipLevel.badge;
      }

      if (this.vipBadgeImage) {
        return this.vipBadgeImage;
      }

      return require('@/assets/img/ranks/admin.svg');
    }
  },

  mounted() {
    // SADECE authUser için fetch
    if (!this.vipLevel && !this.vipLevelData) {
      this.fetchUserVip();
    }
  },

  methods: {
    ...mapActions('vip', ['fetchUserVip'])
  }
};
</script>


<style scoped>
.box-rank {
  width: 38px;
  height: 28px;
  position: relative;
  margin-left: 5px;
}

.rewards-rakeback .box-rank {
  width: 29px;
  height: 22px;
  margin-left: 0;
}

.box-rank .rank-inner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-rank .rank-inner img {
  max-width: 100%;
  max-height: 100%;
}
</style>
